<template>
  <app-wrapper>
    <app-header :loan="loan" medium-max-width="max-w-1000">
      <template #navigation>
        <div class="max-w-200">
          <h5 class="font-zen-dots text-white">
            <AppLogo/>
          </h5>
        </div>
      </template>
      <template #top>
        <div class="w-full flex items-center">
          <div class="flex-auto">
            Your desired loan amount
            <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
          </div>
          <div class="flex-initial">
            <i class="fa fa-check-circle text-success text-7xl"/>
          </div>
        </div>
      </template>
    </app-header>

    <app-body medium-max-width="max-w-500" footer>
      <template #title>
        Verify Income In Process...
      </template>

      <template #text>
        <div>
          <div class="flex items-center mb-3">
            <i class="fa fa-info-circle text-info text-2xl"/>
            <p  class="ml-2">{{ lightModeMessage }}</p>
          </div>
        </div>
      </template>

      <template v-if="!paystubReuploadNeeded" #main>
        <div v-if="!showManualForm">
          <div class="mt-6 text-center">
            <button
              @click="showManualForm = true"
              class="text-blue-600 hover:text-blue-800 font-semibold underline"
            >
              Enter bank details manually
            </button>
          </div>
        </div>

        <div v-else>
          <div class="mb-4">
          </div>

          <ManualBankAccountForm
            :loan="loan"
            :user="user"
          />
        </div>
      </template>

      <template v-else #main>
        <div class="mt-6">
          <div class="flex justify-center items-center gap-4">
            <button
              @click="reuploadPaystubs(true)"
              class="rounded w-full p-4 border hover:bg-blue-50 border-gray-500 text-grey-500"
            >
              Yes
            </button>
            <button
              @click="reuploadPaystubs(false)"
              class="rounded w-full p-4 border hover:bg-blue-50 border-2 border-blue-800 text-blue-500"
            >
              No
            </button>
          </div>
          <p class="text-center text-gray-600 mt-4 text-sm">
            If yes, you will need to provide another paystub
          </p>
        </div>
      </template>
    </app-body>
  </app-wrapper>
</template>

<script>
import AppLogo from './../../../components/AppLogo';
import ManualBankAccountForm from '../../../components/ManualBankAccountForm.vue';

export default {
  mixins: [
    require('../../../mixins/InteractsWithGtag').default,
    require('../../../mixins/PageViewAnalytics').default
  ],
  components: {
    AppLogo,
    ManualBankAccountForm,
  },
  props: {
    user: {},
    loan: {},
    lightModeMessage: String,
    paystubReuploadNeeded: Boolean,
    manual: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      gTagPageName: 'VERIFY_INCOME_PROCESSING',
      showManualForm: true,
    };
  },

  created() {
  },

  methods: {
    reuploadPaystubs(answer) {
      this.$http
        .post(`/signup/light-mode-income-verification/${this.loan.id}/paystub-answer`, {
          answer: answer,
        }, {
          headers: { 'Content-Type': 'application/json' },
        })
        .then(
          () => {
            this.loading = false;
            window.location.reload();
          },
          (error) => {
            console.error(error);
            window.location.reload();
          }
        );
    },
  },
};
</script>